function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23 11.75C24.2375 11.75 25.25 12.7625 25.25 14V23C25.25 24.2375 24.2375 25.25 23 25.25C21.7625 25.25 20.75 24.2375 20.75 23V14C20.75 12.7625 21.7625 11.75 23 11.75ZM22.9775 0.5C10.5575 0.5 0.5 10.58 0.5 23C0.5 35.42 10.5575 45.5 22.9775 45.5C35.42 45.5 45.5 35.42 45.5 23C45.5 10.58 35.42 0.5 22.9775 0.5ZM23.0001 40.9997C13.0551 40.9997 5.00007 32.9447 5.00007 22.9997C5.00007 13.0547 13.0551 4.99971 23.0001 4.99971C32.9451 4.99971 41.0001 13.0547 41.0001 22.9997C41.0001 32.9447 32.9451 40.9997 23.0001 40.9997ZM25.25 32.0003C25.25 33.2429 24.2426 34.2503 23 34.2503C21.7573 34.2503 20.75 33.2429 20.75 32.0003C20.75 30.7577 21.7573 29.7503 23 29.7503C24.2426 29.7503 25.25 30.7577 25.25 32.0003Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: -22,
  y1: 23,
  x2: 23,
  y2: 68,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00BAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007CFF"
})));

function SvgAlertIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.540498a1.svg";
export { ForwardRef as ReactComponent };